import CONSTANTS from '../constants';

export const alerts = {
  success,
  error,
  clear,
  getToastSettings
};

function success(code, message) {
  return { type: CONSTANTS.ACTIONS.ALERTS.SUCCESS, code, message };
}

function error(code, message) {
  return { type: CONSTANTS.ACTIONS.ALERTS.ERROR, code, message };
}

function clear() {
  return { type: CONSTANTS.ACTIONS.ALERTS.ERROR, code: null, message: null };
}

function getToastSettings(toast = 0) {
  return { type: CONSTANTS.ACTIONS.ALERTS.TOAST_SETTINGS, toast };
}
